import { GuarantorsConsumerRenderProps, withGuarantorsContext } from 'components/guarantors/GuarantorsContext';
import VirtualizedTable from 'components/layout/VirtualizedTable';
import React from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { BroadcastEmailDto } from 'ts-types/api.types';
import { isoToDisplayTimestamp } from 'utils/dateUtils';

interface Props extends MessageSourceProps, GuarantorsConsumerRenderProps {
  emails: BroadcastEmailDto[];
}

const BroadcastEmailRunTableView = (props: Props) => {

  const {getMessage} = props;

  const emails = props.emails;

  const sendTimestampCellRenderer = ({rowData}: any) => {
    return <div>
      {isoToDisplayTimestamp(rowData.sendTimestamp)}
    </div>
  }

  const renderEmailsSegment = (): JSX.Element => {

    return (
        <VirtualizedTable
            rowCount={emails.length}
            rowGetter={emailRowGetter}
            rowRenderer={emailRowRenderer}
            columns={[
              {
                width: 200,
                flexGrow: 1,
                label: (getMessage("patientEmail.table.header.email")),
                dataKey: "email"
              },
              {
                width: 200,
                label: (getMessage("patientEmail.table.header.status")),
                dataKey: "status"
              },
              {
                width: 200,
                label: (getMessage("patientEmail.table.header.remoteStatus")),
                dataKey: "remoteStatus"
              },
              {
                width: 200,
                flexGrow: 1,
                label: (getMessage("patientEmail.table.header.remoteDescription")),
                dataKey: "remoteDescription"
              },
              {
                width: 200,
                label: (getMessage("patientEmail.table.header.sendAt")),
                dataKey: "sendTimestamp",
                cellRenderer: (sendTimestampCellRenderer)
              }
            ]}
        />

    );
  };

  const emailRowGetter = ({index}: any) => {

    Object.assign(emails[index], {index: index + 1});

    return emails[index];
  };

  const emailRowRenderer = ({className, columns, index, key, style}: any) => {
    const a11yProps = {'aria-rowindex': index + 1};

    return (
        <div
            {...a11yProps}
            className={className}
            key={key}
            role="row"
            style={style}
        >
          {columns}
        </div>
    );
  };

  return renderEmailsSegment();
}

export default withMessages(withGuarantorsContext(BroadcastEmailRunTableView));
